import { RewardCode, TradeStatus, TransactionCode } from '@services/appsync/types';

export const TRANSACTION_FILTER: TransactionCode[] = [
  TransactionCode.FEE_BANK,
  TransactionCode.DIVIDEND,
  TransactionCode.PLAN_FEE,
  // Note: Don't include these records as they are covered by Trades
  // TransactionCode.DIVIDEND_REINVESTMENT  (See Trades using isDrip field)
  // TransactionCode.DEPOSIT_ESCROW
  // TransactionCode.TRADE_BUY
  // TransactionCode.TRADE_AUTO_BUY
  // TransactionCode.TRADE_SELL
  // TransactionCode.REVOKE
  // TransactionCode.WITHDRAWAL
];

export const TRADES_FILTER: TradeStatus[] = [
  TradeStatus.CREATED,
  TradeStatus.OPENED,
  TradeStatus.PENDING_CANCEL,
  TradeStatus.PENDING_FUNDING,
  TradeStatus.FUNDED,
  TradeStatus.SCHEDULED,
  TradeStatus.SETTLED,
  TradeStatus.CANCELED,
  TradeStatus.FAILED,
];

export const REWARDS_FILTER: RewardCode[] = [
  RewardCode.DEBIT,
  RewardCode.GIFT_REWARD,
  RewardCode.INSTANT_EARN,
  RewardCode.INSTANT_EARNING,
  RewardCode.PROMO_DIVIDEND_REWARD,
  RewardCode.REFEREE,
  RewardCode.REFERRAL,
];
